import { render, staticRenderFns } from "./ConfigCategoriesDesktop.vue?vue&type=template&id=066865fa"
import script from "./ConfigCategoriesDesktop.vue?vue&type=script&lang=js"
export * from "./ConfigCategoriesDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports